import { colors, radius, shadowM, spacing } from '@ardoq/design-tokens';
import styled from 'styled-components';
import {
  DrawerOrientation,
  DrawerWrapperProps,
  ModalDrawerSize,
} from './types';
import { forwardRef, PropsWithChildren } from 'react';

const getHeightOfDrawer = (
  drawerSize: ModalDrawerSize,
  orientation: DrawerOrientation
) => {
  if (orientation === 'vertical') return '100vh';

  if (drawerSize === 'small') return '49vh';
  if (drawerSize === 'medium') return '67vh';
  return '85vh';
};

const getWidthOfDrawer = (
  drawerSize: ModalDrawerSize,
  orientation: DrawerOrientation
) => {
  if (orientation === 'horizontal') return '100vw';

  if (drawerSize === 'small') return '20vw';
  if (drawerSize === 'medium') return '67vw';
  return '85vw';
};

const getBorderRadius = (orientation: DrawerOrientation) => {
  return orientation === 'vertical'
    ? `${radius.r16} 0px 0px ${radius.r16}`
    : `${radius.r16} ${radius.r16} 0px 0px`;
};

const DrawerWrapperStyle = styled.div<{
  $drawerSize: ModalDrawerSize;
  $orientation: DrawerOrientation;
}>`
  display: flex;
  flex-direction: column;
  border-radius: ${({ $orientation }) => getBorderRadius($orientation)};
  box-shadow: ${shadowM};
  overflow: hidden;
  background-color: ${colors.surfaceDefault};
  width: ${({ $drawerSize, $orientation }) =>
    getWidthOfDrawer($drawerSize, $orientation)};
  min-height: 240px;
  min-width: 480px;
  gap: ${spacing.s24};
  height: ${({ $drawerSize, $orientation }) =>
    getHeightOfDrawer($drawerSize, $orientation)};
`;

const DrawerWrapper = forwardRef<
  HTMLDivElement,
  PropsWithChildren<DrawerWrapperProps>
>(({ drawerSize = 'medium', orientation = 'horizontal', children }, ref) => (
  <DrawerWrapperStyle
    $drawerSize={drawerSize}
    $orientation={orientation}
    ref={ref}
  >
    {children}
  </DrawerWrapperStyle>
));

export { DrawerWrapper };
